import type { IFileDownloadResponse } from '~/types';

export const setDownloadAnchor = ({
  type,
  file,
  name,
}: IFileDownloadResponse) => {
  const linkSource = `data:${type};base64,${file}`;
  const downloadLink = document.createElement('a');
  downloadLink.download = name;
  downloadLink.href = linkSource;
  downloadLink.click();
};

export const formatFileSize = (size: number): string => {
  if (size <= 0) return '0 Bytes';

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  const i = Math.floor(Math.log(size) / Math.log(1024));

  return `${(size / Math.pow(1024, i)).toFixed(2)} ${units[i]}`;
};

export const base64ToArrayBuffer = (base64: string) => {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

const _isBase64 = (str: string): boolean => {
  try {
    return btoa(atob(str)) === str;
  } catch {
    return false;
  }
};

export const openFileInNewTab = ({ file, type }: IFileDownloadResponse) => {
  const content = _isBase64(file) ? base64ToArrayBuffer(file) : file;

  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
};
